import React from 'react'
import IconLabel from '../../common/icon-label'
import { PersonFill } from 'react-bootstrap-icons'
import FacilitatorLabel from '../../facilitators/label'

const FacilitatorIconLabel = ({
    experience = {}
}) => {

    return (
        <IconLabel
            icon={PersonFill}
        >
            <FacilitatorLabel facilitatorId={experience.facilitatorId} />
        </IconLabel>
    )
}

export default FacilitatorIconLabel